
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__sort-ascending",
  "use": "icon__sort-ascending-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon__sort-ascending\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h20v20H0z\" /><path d=\"M7.5 4.375v-1.25h-5v1.25h5zM10 7.5V6.25H2.5V7.5H10zm2.5 3.125v-1.25h-10v1.25h10zM15 13.75V12.5H2.5v1.25H15zm2.5 3.125v-1.25h-15v1.25h15z\" fill=\"currentColor\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconSortAscendingIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__sort-ascending" {...restProps} />
    })
  